// Make entire product card clickable
// Uses event delegation to handle dynamically loaded cards (e.g., product recommendations)
document.addEventListener('DOMContentLoaded', function() {

  // Handle clicks using event delegation on the document body
  document.body.addEventListener('click', function(e) {
    // Find the closest card-wrapper parent
    const card = e.target.closest('.card-wrapper');

    if (!card) return;

    // Don't navigate if clicking on a button or existing link
    if (e.target.closest('button') || e.target.closest('a') || e.target.closest('.quick-add')) {
      return;
    }

    // Find the product link within the card
    const link = card.querySelector('.card__heading a, .full-unstyled-link');
    if (link && link.href) {
      window.location.href = link.href;
    }
  });
});
